import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import React from 'react';

// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
let singletonClient = null;

const RESIZE_OBSERVER_LOOP_MSG =
  'ResizeObserver loop completed with undelivered notifications';

function shouldIgnoreBugsnagReport(report: { errorMessage?: string }) {
  return (
    typeof report.errorMessage === 'string' &&
    report.errorMessage.includes(RESIZE_OBSERVER_LOOP_MSG)
  );
}

export default (options?: any) => {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  if (singletonClient) {
    return singletonClient;
  } else {
    if (!options?.apiKey) {
      return;
    }
    const userBeforeSend = options.beforeSend;
    const beforeSend = (report: any) => {
      if (shouldIgnoreBugsnagReport(report)) {
        report.ignore();
        return;
      }
      if (typeof userBeforeSend === 'function') {
        userBeforeSend(report);
      }
    };
    singletonClient = bugsnag({ ...options, beforeSend }).use(
      bugsnagReact,
      React,
    );
    return singletonClient;
  }
};
